import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";
import { memo } from "react";
import { OnwardLinkType } from "@/components/OnwardLinks/OnwardLinks.tsx";

type OnwardLinksESIProps = {
  currentUrl: string;
  onwardLinkType: OnwardLinkType;
};
export const OnwardLinksESI = memo(
  ({ currentUrl, onwardLinkType }: OnwardLinksESIProps) => {
    const esiSrc = `/esi/foundit?productUrl=${currentUrl}&onwardLinkType=${onwardLinkType}`;
    return <ESIInclude id="onward-links-esi" src={esiSrc} />;
  },
  () => true,
);

OnwardLinksESI.displayName = "MemoedOnwardLinksESI";
